<template>
  <el-dialog title="分配司机" :visible.sync="dialogVisible" width="800px" @close="handleClose">
    <div v-if="trainingData" class="driver-assign">
      <div class="assign-title">培训任务：{{ trainingData.title }}</div>
      <div class="assign-header">
        <p class="assign-desc">1、选择需要参与此培训的司机</p>

        <!-- 搜索栏 -->
        <el-input
          v-model="searchForm.keyword"
          placeholder="搜索司机姓名、手机号"
          style="width: 300px"
          size="small"
          @keyup.enter="handleSearch"
        >
          <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
        </el-input>
      </div>

      <!-- 司机列表 -->
      <el-table
        :data="driverList"
        @row-click="handleSelectionChange"
        stripe
        size="small"
        max-height="300"
      >
        <!-- <el-table-column type="selection" /> -->

        <el-table-column prop="name" label="司机姓名" />

        <el-table-column prop="no" label="编号" />
        <el-table-column prop="registerTime" label="注册时间">
          <template slot-scope="scope">
            <span>{{ scope.row.registerTime | dateFormat }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="firstWorkDate" label="首次发班">
          <template slot-scope="scope">
            <span>{{ scope.row.firstWorkDate }}</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 已选择的司机 -->
      <div v-if="selectedDrivers.length > 0" class="selected-drivers">
        <h5>已选择司机（{{ selectedDrivers.length }}人）：</h5>
        <div class="driver-tags">
          <el-tag
            v-for="driver in selectedDrivers"
            :key="driver.id"
            closable
            @close="handleRemoveDriver(driver)"
            style="margin-right: 8px; margin-bottom: 8px"
          >
            {{ driver.name }}
          </el-tag>
        </div>
      </div>

      <div style="margin-top: 20px">
        <span>2、培训截止日期（可不选，不选则不限制）：</span>
        <el-date-picker
          v-model="latestFinishTime"
          type="date"
          placeholder="请选择培训截止日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd 23:59:59"
          style="width: 200px"
        />
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleConfirm" :disabled="selectedDrivers.length === 0">
        确定分配
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { searchDriver } from "@/api/driver";
import { createDriverTraining } from "@/api/new_training";
export default {
  name: "DriverAssignDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    trainingData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      driverList: [],
      selectedDrivers: [],
      latestFinishTime: null,

      // 搜索表单
      searchForm: {
        keyword: ""
      }
    };
  },
  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val;
        if (val) {
          this.loadDriverList();
        }
      },
      immediate: true
    }
  },
  methods: {
    // 加载司机列表
    async loadDriverList() {
      try {
        const res = await searchDriver(this.searchForm.keyword);
        this.driverList = res.data || [];
      } catch (error) {
        this.$message.error("加载司机列表失败");
        console.error(error);
      }
    },

    // 搜索
    handleSearch() {
      this.loadDriverList();
    },

    // 选择变化
    handleSelectionChange(selection) {
      // 存在则删除，不存在则添加
      const index = this.selectedDrivers.findIndex((d) => d.id === selection.id);
      if (index > -1) {
        this.selectedDrivers.splice(index, 1);
      } else {
        this.selectedDrivers.push(selection);
      }
    },

    // 移除司机
    handleRemoveDriver(driver) {
      const index = this.selectedDrivers.findIndex((d) => d.id === driver.id);
      if (index > -1) {
        this.selectedDrivers.splice(index, 1);
      }
    },

    // 确认分配
    async handleConfirm() {
      if (this.selectedDrivers.length === 0) {
        this.$message.warning("请选择要分配的司机");
        return;
      }

      const driverIds = this.selectedDrivers.map((driver) => driver.id);
      await createDriverTraining({
        trainingId: this.trainingData.id,
        driverIds: driverIds,
        latestFinishTime: this.latestFinishTime
      });
      this.$emit("confirm");
      this.$message.success("分配成功");
      this.handleClose();
    },

    // 关闭
    handleClose() {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style lang="less" scoped>
.driver-assign {
  .assign-title {
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: bold;
  }
  .assign-header {
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid #e4e7ed;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h4 {
      color: #303133;
      font-size: 16px;
    }

    .assign-desc {
      margin: 0;
      color: #909399;
      font-size: 14px;
    }
  }

  .selected-drivers {
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #e4e7ed;

    h5 {
      margin: 0 0 12px 0;
      color: #303133;
      font-size: 14px;
    }

    .driver-tags {
      .el-tag {
        margin-right: 8px;
        margin-bottom: 8px;
      }
    }
  }

  .text-muted {
    color: #909399;
  }
}

.dialog-footer {
  text-align: right;
}
</style>
